// Opta MA3 pass map guide: typeId 1 (Pass) at any outcome, excluding events
// carrying qualifier 2 (Cross), 107 (Throw-in) or 123 (Goalkeeper throw) so
// the plotted passes match Opta's definition of a pass. Qualifiers 140/141
// carry the pass end x/y - start x/y come straight off the event like
// TouchMap uses.
const PASS_TYPE_ID = 1;
const PASS_EXCLUDED_QUALIFIER_IDS = [2, 107, 123];
const PASS_END_X_QUALIFIER_ID = 140;
const PASS_END_Y_QUALIFIER_ID = 141;

function isPassMapEvent(e) {
  if (e?.typeId !== PASS_TYPE_ID) return false;
  if (!Number.isFinite(e?.x) || !Number.isFinite(e?.y)) return false;
  if (
    e?.qualifier?.some((q) =>
      PASS_EXCLUDED_QUALIFIER_IDS.includes(q?.qualifierId),
    )
  )
    return false;
  return true;
}

export class PassMap {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "PassMap";
    this.scene = "Player Pass Map";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];

    let passes = options?.opta_events
      ?.filter((e) => e?.playerId === options?.player?.opta_ID)
      ?.filter(isPassMapEvent)
      ?.map((e) => {
        return {
          x: e.x,
          y: e.y,
          endX: parseFloat(
            e.qualifier?.find((q) => q?.qualifierId === PASS_END_X_QUALIFIER_ID)
              ?.value,
          ),
          endY: parseFloat(
            e.qualifier?.find((q) => q?.qualifierId === PASS_END_Y_QUALIFIER_ID)
              ?.value,
          ),
          successful: e.outcome === 1,
        };
      });

    this.data.push({
      name: "Passes",
      value: { text: JSON.stringify(passes ?? []) },
    });

    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Title",
      value: {
        text: options.player?.title || "",
      },
    });
    this.data.push({
      name: "Shirt Number",
      value: {
        text:
          options.player?.shirt_number ??
          options.player?.opta_shirt_number ??
          "",
      },
    });
    this.data.push({
      name: "First Name",
      value: {
        text:
          options.player?.first_name ?? options.player?.opta_first_name ?? "",
      },
    });
    this.data.push({
      name: "Last Name",
      value: {
        text: options.player?.last_name ?? options.player?.opta_last_name ?? "",
      },
    });
    this.data.push({
      name: "First Name Uppercase",
      value: {
        text:
          options.player?.first_name_upper ??
          options.player?.opta_first_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Last Name Uppercase",
      value: {
        text:
          options.player?.last_name_upper ??
          options.player?.opta_last_name?.toUpperCase() ??
          "",
      },
    });
    this.data.push({
      name: "Full Name",
      value: {
        text:
          (options.player?.first_name ??
            options.player?.opta_first_name ??
            "") +
          " " +
          (options.player?.last_name ?? options.player?.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: "Full Name Uppercase",
      value: {
        text:
          (options.player?.first_name_upper ??
            options.player?.opta_first_name?.toUpperCase() ??
            "") +
          " " +
          (options.player?.last_name_upper ??
            options.player?.opta_last_name?.toUpperCase() ??
            ""),
      },
    });
    this.data.push({
      name: "Subtitle",
      value: {
        text: "",
      },
    });
    this.data.push({
      name: "Team Name",
      value: {
        text: options.team?.name || "",
      },
    });

    this.data.push({
      name: "Goal Time",
      value: {
        text: "",
      },
    });

    this.data.push({
      name: "Team Badge",
      value: {
        image: "${user}" + options.team?.variables?.badge || "",
      },
    });
    this.data.push({
      name: "Team Secondary Badge",
      value: {
        image: "${user}" + options.team?.variables?.alt_badge || "",
      },
    });

    if (options?.game?.home_team?._id === options.team?._id) {
      this.data.push({
        name: "Team Type",
        value: {
          text: "home",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.home_team_kit + "_kit_text"
            ] || "",
        },
      });
    } else {
      this.data.push({
        name: "Team Type",
        value: {
          text: "away",
        },
      });
      this.data.push({
        name: "Team Kit BG Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_bg"
            ] || "",
        },
      });
      this.data.push({
        name: "Team Kit Text Colour",
        value: {
          colour:
            options.team?.variables?.[
              options.game?.away_team_kit + "_kit_text"
            ] || "",
        },
      });
    }

    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
